// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2ZOhL","footer":"ChangeClinic_footer__2ufma"};